<div class="overlay" *ngIf="visible">
  <div class="modal-content">
    <div class="spinner"></div>
    <p>{{ message }}</p>
  </div>
</div>
